export default __webpack_public_path__ + "static/media/30.732c133e.jpg";